function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-serverless {\n        fill: currentColor;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Aws_cloud_computing_data_center_database_servers",
  "data-name": "Aws, cloud computing, data center, database, servers"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9028",
  "data-name": "Path 9028",
  className: "cls-serverless",
  d: "M25.136,18.227a.369.369,0,0,0,.364-.373v-4.48A.369.369,0,0,0,25.136,13H11.864a.369.369,0,0,0-.364.373v4.48a.369.369,0,0,0,.364.373h9.545V20.84H11.864a.369.369,0,0,0-.364.373v4.48a.369.369,0,0,0,.364.373H25.136a.369.369,0,0,0,.364-.373v-4.48a.369.369,0,0,0-.364-.373h-3V18.227Zm-.364,7.093H12.227V21.587H24.773ZM12.227,13.747H24.773V17.48H12.227Z",
  transform: "translate(-11.5 -13)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9029",
  "data-name": "Path 9029",
  className: "cls-serverless",
  d: "M22.182,20a1.214,1.214,0,1,0,1.182,1.213A1.2,1.2,0,0,0,22.182,20Zm0,1.68a.467.467,0,1,1,.455-.467A.461.461,0,0,1,22.182,21.68Z",
  transform: "translate(-19.273 -18.693)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9030",
  "data-name": "Path 9030",
  className: "cls-serverless",
  d: "M40.182,20a1.214,1.214,0,1,0,1.182,1.213A1.2,1.2,0,0,0,40.182,20Zm0,1.68a.467.467,0,1,1,.455-.467A.461.461,0,0,1,40.182,21.68Z",
  transform: "translate(-34 -18.693)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9033",
  "data-name": "Path 9033",
  className: "cls-serverless",
  d: "M40.182,20a1.214,1.214,0,1,0,1.182,1.213A1.2,1.2,0,0,0,40.182,20Zm0,1.68a.467.467,0,1,1,.455-.467A.461.461,0,0,1,40.182,21.68Z",
  transform: "translate(-30.727 -18.693)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9031",
  "data-name": "Path 9031",
  className: "cls-serverless",
  d: "M67.182,64.427A1.214,1.214,0,1,0,66,63.213,1.2,1.2,0,0,0,67.182,64.427Zm0-1.68a.467.467,0,1,1-.455.467A.461.461,0,0,1,67.182,62.747Z",
  transform: "translate(-56.091 -52.853)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9032",
  "data-name": "Path 9032",
  className: "cls-serverless",
  d: "M49.182,64.427A1.214,1.214,0,1,0,48,63.213,1.2,1.2,0,0,0,49.182,64.427Zm0-1.68a.467.467,0,1,1-.455.467A.461.461,0,0,1,49.182,62.747Z",
  transform: "translate(-41.364 -52.853)"
}));

function SvgServerless(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-aws",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.067,
    viewBox: "0 0 14 13.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerless);
export default __webpack_public_path__ + "static/media/serverless.8e0dc1b8.svg";
export { ForwardRef as ReactComponent };